
import * as actionTypes from '../actions';
import { LOAD_CURRENT_USER_SESSION_SUCCESS, LOGOUT_SUCCESS } from '../../../redux/actions/auth';
import { parseTaskResults } from '../components/Utils';

import {
  initialState as debitorState,
  reducer as debitorReducer,
  initCurrentDebitorTypes
} from './debitor';

import {
  initialState as connectionState,
  reducer as connectionReducer,
  initCurrentConnectionTypes,
} from './connection';

import {
  initialState as deviceState,
  reducer as deviceReducer,
  initCurrentDeviceTypes
} from './device';

import {
  initialState as cardOrderState,
  reducer as cardOrderReducer
} from './card';

import {
  initialState as keyOrderState,
  reducer as keyOrderReducer
} from './key';

import {
  initialState as reportState,
  reducer as reportReducer
} from './report';

import {
  initialState as employeeState,
  reducer as employeeReducer
} from './employee';

import {
  initialState as msAuthenticatorState,
  reducer as msAuthenticatorReducer
} from './ms_authenticator';

const initialState = {
  loaded: false,
  taskCounter: 0,
  ...connectionState,
  ...debitorState,
  ...deviceState,
  ...cardOrderState,
  ...keyOrderState,
  ...reportState,
  modemOrders: [],
  ...employeeState,
  ...msAuthenticatorState,
};

export default (state = initialState, action) => {
  let newState = null;

  // LOAD_TASKS
  switch (action.type) {
    case actionTypes.LOAD_TASKS:
      return {
        ...state,
        loading: true
      };
    case LOAD_CURRENT_USER_SESSION_SUCCESS:
    case actionTypes.LOAD_TASKS_SUCCESS: {
      const allTasks = parseTaskResults(action.result, state, action.taskType);
      const debitorTaskTypes = initCurrentDebitorTypes(state);
      const deviceTaskTypes = initCurrentDeviceTypes(state);
      const connectionTaskTypes = initCurrentConnectionTypes(state, action.result);
      return {
        ...state,
        loading: false,
        ...allTasks,
        ...debitorTaskTypes,
        ...deviceTaskTypes,
        ...connectionTaskTypes,
      };
    }
    case actionTypes.LOAD_TASKS_FAILURE:
      return {
        ...state,
        loading: false
      };
    // reinitialize on logout
    case LOGOUT_SUCCESS:
      return {
        ...state,
        ...initialState
      };
    default:
      break;
  }

  // debitor
  newState = debitorReducer(state, action);
  if (newState) return newState;

  // connection
  newState = connectionReducer(state, action);
  if (newState) return newState;

  // device
  newState = deviceReducer(state, action);
  if (newState) return newState;

  // card orders
  newState = cardOrderReducer(state, action);
  if (newState) return newState;

  // key orders
  newState = keyOrderReducer(state, action);
  if (newState) return newState;

  // reports
  newState = reportReducer(state, action);
  if (newState) return newState;

  // employee tasks
  newState = employeeReducer(state, action);
  if (newState) return newState;

  // msAuthenticator tasks
  newState = msAuthenticatorReducer(state, action);
  if (newState) return newState;
  
  return { ...state };
}
